const t = "locale-changed", e = class e extends CustomEvent {
  constructor(a) {
    super(t, { detail: { locale: a }, bubbles: !0, composed: !0 });
  }
};
e.EVENT_NAME = t;
let s = e;
export {
  t as EVENT_NAME,
  s as default
};
//# sourceMappingURL=LocaleChangeEvent.js.map
